import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Field, PrimaryButton } from "../../../components/landing/ui";

const schema = Yup.object({
  fullname: Yup.string().trim().required("Full name is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  message: Yup.string().trim().required("Message is required"),
});

// Opens a pre-filled Gmail compose window (no backend call).
const openMail = ({ fullname, email, message }) => {
  const body = `Hi, my name is ${fullname}. ${message} (${email})`;
  window.open(
    `https://mail.google.com/mail/?view=cm&fs=1&to=prepaidnigeria@gmail.com&su=${encodeURIComponent(
      "Prepaid Meter Enquiries"
    )}&body=${encodeURIComponent(body)}`,
    "_blank",
    "noopener"
  );
};

export default function ContactForm() {
  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues: { fullname: "", email: "", message: "" },
    validationSchema: schema,
    onSubmit: openMail,
  });
  const bind = (k) => ({
    name: k,
    value: values[k],
    onChange: handleChange,
    onBlur: handleBlur,
    error: (touched[k] && errors[k]) || "",
  });

  return (
    <form
      onSubmit={handleSubmit}
      noValidate
      className="flex w-full flex-col gap-5 rounded-3xl border border-black/5 bg-white p-5 shadow-[0_20px_50px_-20px_rgba(1,6,35,0.2)] sm:p-8"
    >
      <Field label="Full name" placeholder="Your name" autoComplete="name" {...bind("fullname")} />
      <Field label="Email" type="email" placeholder="you@example.com" autoComplete="email" {...bind("email")} />
      <div className="flex flex-col gap-1.5">
        <label className="text-sm font-semibold text-primary-dark">Message</label>
        <textarea
          rows={5}
          placeholder="How can we help?"
          {...{ name: "message", value: values.message, onChange: handleChange, onBlur: handleBlur }}
          className={`w-full resize-none rounded-xl bg-[#F3F3F7] px-4 py-3 text-base outline-none ring-2 transition placeholder:text-[#9AA0B4] ${
            touched.message && errors.message ? "ring-red-400" : "ring-transparent focus:ring-primary-light/40"
          }`}
        />
        {touched.message && errors.message && (
          <span className="text-sm font-medium text-red-600">{errors.message}</span>
        )}
      </div>
      <PrimaryButton type="submit">Send message</PrimaryButton>
    </form>
  );
}
